const DOMAIN_API = "/api/v1"


export function fetch_api_json(method, suffix_url, body) {
    return fetch(DOMAIN_API + suffix_url, {
        method: method,
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        body: body ? JSON.stringify(body) : undefined
    }).then((response) => {
        return response.json();
    }).catch((error) => console.error(error));
}


// deletion does not return JSON
function unset_api_json(method, suffix_url) {
    return fetch(DOMAIN_API + suffix_url, {
        method: method,
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        }
    }).then((response) => {
        return response.status === 204
    }).catch((error) => console.error(error));
}


export function login(email : String,password  : String) {
    const url = DOMAIN_API +"/accounts/log_in/"
    return fetch(url,{
        method:"POST",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            email: email,
            password: password
        })
    }).then((response) => {
        if(response.status===200){
            return response.json();
        }else{
            return false;
        }
    }).catch((error) => { console.error(error);return false;})
}

export function logout () {
    const url = DOMAIN_API +"/accounts/log_out/"
    return fetch(url,{
        method:"POST",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
        })
    }).then((response) => {
        return response.status === 204
    }).catch((error) => { console.error(error);return false;})
}

export function getFeedNormal(cursor){
  let url = "/post/feed/normal?cursor=";
  if(cursor!==undefined){
      url = url + cursor;
  }

  return fetch_api_json("get", url);
}


export function getFeedFocus(cursor){
  let url = "/post/feed/focus?cursor=";
  if(cursor!==undefined){
      url = url + cursor;
  }
  return fetch_api_json("get", url);
}

export function getAuthorFeed(author,cursor){
  let url = "/post/feed/author?author="+author+"&cursor=";
  if (cursor !== undefined) {
      url = url + cursor;
  }

  return fetch_api_json("get", url);
}

export function savePost(idPost : number){

}

export function getPost(idPost : number){
  return fetch_api_json("get", "/post/"+idPost+"/");
}

export function getAllContact(){
  return fetch_api_json("get", "/poi_contact/");
}

export function getContact(id){
  return fetch_api_json("get", "/poi_contact/"+id);
}

export function getAllTheme(){
  return fetch_api_json("get", "/poi_theme/tree");
}

export function getTheme(id){
  return fetch_api_json("get", "/poi_theme/"+id);
}

export function getAllGeo(){
  return fetch_api_json("get", "/poi_geo/tree");
}

export function getAllEntity(){
  return fetch_api_json("get", "/poi_entity/");
}

export function getEntity(id){
  return fetch_api_json("get", "/poi_entity/"+id);
}

export function getBookmark(){
  return fetch_api_json("get", "/bookmark/");
}

export function setBookmark(id:number,action:string){
  return fetch_api_json("post", "/bookmark/"+id+"/"+action);
}

export function getFocusContact(){
  return fetch_api_json("get", "/focus_contact");
}

export function getFocusTheme(){
  return fetch_api_json("get","/focus_theme");
}

export function getFocusEntity(){
  return fetch_api_json("get", "/focus_entity/");
}

export function setFocusContact(id:number,action:string){
  return action.set
    ? fetch_api_json("post", "/focus_contact/"+id+"/"+action)
    : unset_api_json("post", "/focus_contact/"+id+"/"+action);
}

export function setFocusTheme(id:number,action:string){
  return action.set
    ? fetch_api_json("post", "/focus_theme/"+id+"/"+action)
    : unset_api_json("post", "/focus_theme/"+id+"/"+action);
}

export function setFocusEntity(id:number,action:string){
  return action.set
    ? fetch_api_json("post", "/focus_entity/"+id+"/"+action)
    : unset_api_json("post", "/focus_entity/"+id+"/"+action);
}

export function setNotifyContact(id:number,action:string){
  return action.set
    ? fetch_api_json("post", "/notify_contact/"+id+"/"+action)
    : unset_api_json("post", "/notify_contact/"+id+"/"+action);
}

export function setNotifyTheme(id:number,action:string){
  return action.set
    ? fetch_api_json("post", "/notify_theme/"+id+"/"+action)
    : unset_api_json("post", "/notify_theme/"+id+"/"+action);
}

export function setNotifyEntity(id:number,action:string){
  return action.set
    ? fetch_api_json("post", "/notify_entity/"+id+"/"+action)
    : unset_api_json("post", "/notify_entity/"+id+"/"+action);
}

export function customFeed(cursor,contact,entite,theme){
    const c = cursor === undefined ? "" : cursor;

    const query = {"contacts" : contact, "entities": entite, "themes" : theme, types: []};
    let encode = encodeURIComponent(JSON.stringify(query));

    return fetch_api_json("get", "/post/feed/custom?query="+encode+"&cursor="+c);
}

export function getOneContact(id){
  return fetch_api_json("get", "/poi_contact/"+id);
}

export function getOneEntity(id){
  return fetch_api_json("get", "/poi_entity/"+id);
}

export function getOneTheme(id){
  return fetch_api_json("get", "/poi_theme/"+id);
}

export function getMyProfil(){
    return fetch_api_json("get", "/user/me/");
}

export function editMyProfil(user){
    const url = DOMAIN_API +"/user/"+user.id
    return fetch(url,{
        method:"PUT",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            user: user,
        })
    }).then((response) => {
        if(response.status===200){
            return response.json();
        }else{
            return false;
        }
    }).catch((error) => { console.error(error);return false;})
}

export function searchPost(cursor,search,offset){
    const off = offset === undefined ? 0 : offset;
    const c = cursor === undefined ? null : cursor ;
    return fetch_api_json("get", "/post/semantic_search?query="+search+"&offset="+off+"&cursor="+c);
}

export function searchContact(search){
  return fetch_api_json("get", "/poi_contact/semantic_search?query="+search);
}

export function searchEntity(search){
  return fetch_api_json("get", "/poi_entity/semantic_search?query="+search);
}

export function getListComments(id){
    return fetch_api_json("get", "/post/"+id+"/comments");
}


export function addComment(comment){
    const url = DOMAIN_API +"/post/comment"
    return fetch(url,{
        method:"POST",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(comment)
    }).then((response) => {
        if(response.status===200){
            return response.json();
        }else{
            return false;
        }
    }).catch((error) => { console.error(error);return false;})
}


export function deleteComment(comment_id) {
  return fetch_api_json("DELETE", `/post/comment/${comment_id}`)
}


export function updateComment(id, post_comment) {
  return fetch_api_json("PUT", `/post/comment/${id}`, {post_comment})
}


export function getAllUser(){
    return fetch_api_json("get", "/user/");
}

export function getProfil(id){
    return fetch_api_json("get", "/user/"+id);
}


export function getAppConfig(key){
    return fetch_api_json("get", "/app_config/" + key);
}

export function getAppConfigJsonValue(key){
    return fetch_api_json("get", "/app_config/" + key).then(x => {
      try {
        return JSON.parse(x.value)
      } catch(error) {
        return undefined;
      }
    })
}

export function getTrendingAll(day){
    if(day === '' || day === undefined){
      day = 30;
    }
    return fetch_api_json("get", "/trending/all?days="+day);
}

export function getPostsDaysAgo(feed_mode, day_ago){
    return fetch_api_json("get", `/post/${feed_mode}/days_ago?days=${day_ago}`);

}

export function getLinks(){
    return fetch_api_json("get", "/poi_link")
}

export function getAffiliations(){
  return fetch_api_json("get", "/poi_affiliation/full");
}

export function getGrid(theme_id){
  // swallow error and return null
  return fetch_api_json("get", `/grid/${theme_id}`).then((x) => {
    if (x && x.errors) {
      console.log("getGrid got errors: ", x.errors);
      return null;
    }
    return x;
  })
}

export function upsertGridCE(theme_id, type, ce_id, params){
    return fetch_api_json("post", `/grid/${theme_id}/${type}/${ce_id}`, params)
}

export function deleteGridCE(theme_id, type, ce_id){
    return fetch_api_json("DELETE", `/grid/${theme_id}/${type}/${ce_id}`)
}

export function changeOwner(theme_id, user_id){
    return fetch_api_json("POST", `/grid/${theme_id}/change_owner/${user_id}`, {})
}

export function updateGrid(theme_id, params){
    return fetch_api_json("POST", `/grid/${theme_id}/update`, params)
}

export function getCustomMap(theme_id){
  return fetch_api_json("get", `/custom_map/${theme_id}`).then((x) => {
    if (x && x.errors) {
      console.log("getCustomMap got errors: ", x.errors);
      return null;
    }
    return x;
  })
}

export function customMapNotifyMissingNode(theme_id, node_id){
  return fetch_api_json(
    "POST",
    `/custom_map/${theme_id}/notify_missing_node/${node_id}`,
    {}
  )
}
